import { useEffect, useRef, useReducer } from '@wordpress/element';

// adapted from https://www.smashingmagazine.com/2020/07/custom-react-hook-fetch-cache-data/
// example application here: https://codesandbox.io/s/usefetch-demo-clt9o
// usage:   const { status, data, error } = useFetch(url);
export const useFetch = (url) => {
	const cache = useRef({});

	// initial state, no preloaded data
	const initialState = {
		status: 'idle',
		error: null,
		data: [],
	};

	// reducer function to update state depending on current status of fetch
	const reducer = (state, action) => {
		switch (action.type) {
			case 'FETCHING':
				return { ...initialState, status: 'fetching' };
			case 'FETCHED':
				return {
					...initialState,
					status: 'fetched',
					data: action.payload,
				};
			case 'FETCH_ERROR':
				return {
					...initialState,
					status: 'error',
					error: action.payload,
				};
			default:
				return state;
		}
	};
	// useReducer instead of useState to set multiple values simultaneously and prevent unnecessary rerenders.
	const [state, dispatch] = useReducer(reducer, initialState);

	useEffect(() => {
		let cancelRequest = false;
		if (!url) return undefined;
		const fetchData = async () => {
			dispatch({ type: 'FETCHING' });
			if (cache.current[url]) {
				const data = cache.current[url];
				dispatch({ type: 'FETCHED', payload: data });
			} else {
				try {
					const response = await fetch(url);
					const data = await response.json();
					cache.current[url] = data;
					if (!cancelRequest) {
						dispatch({ type: 'FETCHED', payload: data });
					}
				} catch (error) {
					if (!cancelRequest) {
						dispatch({
							type: 'FETCH_ERROR',
							payload: error.message,
						});
					}
				}
			}
		};

		fetchData();

		// cleanup switch to prevent data leak on unmount
		return function cleanup() {
			cancelRequest = true;
		};
	}, [url]);

	return state;
};

export const slugify = (string) =>
	string
		.toString()
		.toLowerCase()
		.replace(/\s+/g, '-') // Replace spaces with -
		.replace(/[^\w\-]+/g, '') // Remove all non-word chars
		.replace(/\-\-+/g, '-') // Replace multiple - with single -
		.replace(/^-+/, '') // Trim - from start of text
		.replace(/-+$/, ''); // Trim - from end of text
